export enum AssessmentType {
  PRE_ASSESSMENT = 'PRE_ASSESSMENT',
  POST_ASSESSMENT = 'POST_ASSESSMENT',
  Final_ASSESSMENT = 'Final_ASSESSMENT',
  PATHOLOGY_ANATOMY = 'PATHOLOGY_ANATOMY',
}
